$(document).ready(function () {
  function init() {
    if (window.location.pathname.includes("cart")) {
      function initCarPage() {
            let sendObject = {
              line_items: window.spendify.cart,
              customer_tags: [],
              test: true,
            };
            console.log("JSON", JSON.stringify(sendObject));
            fetch(
              `http://spendify-prod.herokuapp.com/api/v1/deals/cart/inspect/?shop=${Shopify.shop}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(sendObject),
              }
            )
              .then((response) => response.json())
              .then((data) => {
                console.log("Response", data);
                if (data.code) {
                  addCodeToSubmitAction(data.code);
                }
                updateLineItems(data.line_items, data.flat_discount);
              })
              .catch((err) => console.error(err));
      }

      function addCodeToSubmitAction(code) {
        console.log('code',code);
        document.querySelectorAll(
          '[action="/cart"]'
        ).forEach(form => {
          form.action = `/cart?discount=${code}`
		});
      }

      function updateLineItems(items, flatDiscount) {
        if (flatDiscount !== "") {
          updateCartSubtotal(flatDiscount);
          for (let index = 0; index < items.length; index++) {
            let textPattern = `${items[index].line_item_message}`;
            const title = document.querySelector(
              `[data-key="${items[index].key}_title"]`
            );
            title.innerHTML = textPattern;
          }
        } else {
          let totalDiscount = 0;
          for (let index = 0; index < items.length; index++) {
            let textPattern = `${items[index].line_item_message}`;
            const currentDiscountValue = items[index].original_price - items[index].current_discount;
            let pricePattern = `£${currentDiscountValue.toFixed(2)}`;
            const titles = document.querySelectorAll(
              `[data-key="${items[index].key}_title"]`
            );
            titles.forEach(title => { 
		  		title.innerHTML = textPattern;
            	title.style.display = "block";
			});
//             title.innerHTML = textPattern;
//             title.style.display = "block";
            if (items[index].current_discount) {
              totalDiscount += items[index].current_discount;
              const prices = document.querySelectorAll(
                `[data-key="${items[index].key}_price"]`
              );
              console.log(`[data-key="${items[index].key}_price"]`);
              prices.forEach((price) => {
                try {
                  price.previousElementSibling.style.setProperty(
                    "text-decoration",
                    "line-through"
                  );
                } catch (err) {}
                price.innerHTML = pricePattern;
                price.style.display = "block";
              });
            }
          }
          updateCartSubtotal(totalDiscount);
        }
      }

      function updateCartSubtotal(totalDiscount) {
        if (totalDiscount > 0) {
          const discountedPriceParagraphs = document.querySelectorAll(
            ".cart__subtotal__discount"
          );
          for (let i = 1; i < 3; i++) {
            let discountedPriceParagraph = discountedPriceParagraphs[i];
            try {
              discountedPriceParagraph.previousElementSibling.style.textDecoration =
                "line-through";
            } catch (err) {}
            const subtotal =
              parseInt(discountedPriceParagraph.getAttribute("data-price")) /
              100;
            discountedPriceParagraph.style.setProperty("color", "#d9534f");
            discountedPriceParagraph.style.setProperty("font-weight", "bold");
            discountedPriceParagraph.style.setProperty("font-size", "20px");
            const finalSubtotal = subtotal - totalDiscount;
            discountedPriceParagraph.innerHTML = `£${finalSubtotal.toFixed(2)}`;
          }
        }
      }

      function reloadWhenQuantityChangesInCart(ns, fetch) {
        if (typeof fetch !== "function") return;

        ns.fetch = function () {
          const response = fetch.apply(this, arguments);

          response.then((res) => {
            if (
              [
                `${window.location.origin}/cart/add.js`,
                `${window.location.origin}/cart/update.js`,
                `${window.location.origin}/cart/change.js`,
                `${window.location.origin}/cart/clear.js`,
              ].includes(res.url)
            ) {
              res
                .clone()
                .json()
                .then((data) => window.location.reload());
            }
          });

          return response;
        };
      }

      // document
      //   .querySelector('[action="/cart"]')
      //   .addEventListener("submit", (event) => {});

      initCarPage();
      reloadWhenQuantityChangesInCart(window, window.fetch);
    } else {
      const addToCardBtn = document.querySelector('[name="add"]');
      let currentVariantId = null;
      function sendRequest() {
        const node = document.querySelector("#variant_shoptrade");
        if (!node) {
          return;
        }
        let variantId = getParameterByName("variant");
        const productId = node.getAttribute("data-product-id");
        let customerTags = node.getAttribute("data-tags").split(",");
        customerTags.splice(-1, 1);
        if (!variantId) {
          variantId = node.getAttribute("value");
        }
        let postObject = {
          cart_items: [],
          variant_id: variantId,
          product_id: productId,
          customer_tags: customerTags,
          variant_price: window.spendify.variant_price
        };
        currentVariantId = variantId;
        fetch("/cart.json", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            let items = data.items;
            items.forEach((item) => {
              let object = {
                variant_id: item.variant_id,
                total_price: item.final_line_price,
                quantity: item.quantity,
                product_id: item.product_id,
              };
              postObject.cart_items.push(object);
            });
            console.log("post", JSON.stringify(postObject));
            fetch(
              `https://spendify-prod.herokuapp.com/api/v1/deals/product/inspect/?shop=${Shopify.shop}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(postObject),
              }
            )
              .then((response) => {
                return response.json();
              })
              .then((data) => {
                const widgetStr = data.widget_html;
                $("#variant_shoptrade").html(`${widgetStr}`);
                let widgetStuff = Object.assign(
                  {},
                  {
                    ...data,
                    widget_html: "",
                  }
                );
                widgetStuff.total_quantity = data.base_quantity;
                widgetStuff.total_price = data.base_price;
                delete data.widget_html;
                if (node.innerHTML != " ") {
                  manageWidget(data, widgetStuff);
                  setupModal();
                }
              })
              .catch((err) => {
                console.log("err", err);
                node.textContent = "";
              });
          })
          .catch((err) => {});
      }

      function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
      }

      function checkAgainstVarian() {
        setInterval(() => {
          let variant = getParameterByName("variant");
          if (variant && variant != currentVariantId) {
            // do stuff
          }
        }, 500);
      }

      function computeBarWidthQty(topTier, qty, lowTier) {
        if (lowTier > 0) {
          lowTier = lowTier - 1;
        }
        let top = topTier - lowTier;
        let quantity = qty - lowTier;
        let width = (quantity * 100.0) / top;
        let marginLeft = 0.85 * width;
        document.getElementById(
          "gif_image"
        ).style.marginLeft = `${marginLeft}%`;
        return width;
      }

      function computeBarWidthSpend(lowTier, topTier, price) {
        let calc =
          Math.round(
            (((price - (lowTier - 1)) * 100.0) / (topTier - (lowTier - 1))) *
              100
          ) / 100;
        let marginLeft = 0.8 * calc;
        document.getElementById(
          "gif_image"
        ).style.marginLeft = `${marginLeft}%`;
        return calc;
      }

      function manageWidget(cartObject, mainObject) {
        const progressBar = document.querySelector(".progress_bar");
        const deal_type = document.querySelector("#shoptrade_discount_type")
          .value;
        const future_deal_discount = document.querySelector(
          "#shoptrade_future_discount"
        );
        let CURRENT_TIER_INDEX = mainObject.selected_tier;
        let determinator = document.querySelector(
          `.shopify_determinator_${CURRENT_TIER_INDEX}`
        );

        function quickAddToCart() {
          try {
            let buttons = document.querySelectorAll(
              ".hc-product-quickadd-button"
            );
            buttons.forEach((button) => {
              button.addEventListener("click", (event) => {
                const quantity = parseInt(
                  event.target.getAttribute("data-qty")
                );
                mainObject.total_quantity =
                  mainObject.total_quantity + quantity;
                mainObject.total_price = cartObject.variant_price * quantity;
                +mainObject.total_price;
                if (deal_type == "spend_tiers") {
                  computeSpendTiersWidget();
                } else {
                  computeQuantityWidget();
                }
              });
            });
          } catch (err) {}
        }
        quickAddToCart();
//         Listeners
        addToCardBtn.addEventListener("click", (event) => {
          let quantity = increase();
          mainObject.total_quantity = mainObject.total_quantity + quantity;
          mainObject.total_price = cartObject.variant_price * quantity;
          +mainObject.total_price;
          if (deal_type == "spend_tiers") {
            computeSpendTiersWidget();
          } else {
            computeQuantityWidget();
          }
        });

        // prevent form from redirecting
        $('[action="/cart/add"]').on("submit", function (event) {
          event.preventDefault();
          jQuery.post("/cart/add.js", $(this).serialize());
        });

        // End Listeners

        function computeSpendTiersWidget() {
          let lowTier = "";
          let highTier = "";
          let currentTierIndex = "";
          let pk = "";
          mainObject.tiers.forEach((tier, index) => {
            if (tier.pk == CURRENT_TIER_INDEX) {
              lowTier = tier.start;
              highTier = tier.end;
              currentTierIndex = index;
              pk = tier.pk;
            }
          });

          if (mainObject.total_price < lowTier && mainObject.total_price > 0) {
            currentTierIndex -= 1;
            lowTier = mainObject.tiers[currentTierIndex].start;
            highTier = mainObject.tiers[currentTierIndex].end;
          } else if (
            mainObject.total_price > highTier &&
            mainObject.total_price > 0 &&
            currentTierIndex < mainObject.tiers.length - 1
          ) {
            currentTierIndex += 1;
            lowTier = mainObject.tiers[currentTierIndex].start;
            highTier = mainObject.tiers[currentTierIndex].end;
          }

          const checkIfLastTier =
            currentTierIndex == mainObject.tiers.length - 1 ? true : false;
          if (
            mainObject.total_price >=
            mainObject.tiers[mainObject.tiers.length - 1].end
          ) {
            try {
              document.querySelector(".card_content").style.display = "none";
            } catch (err) {}
            try {
              document.querySelector(".card_content_congrats").style.display =
                "flex";
            } catch (err) {}
            try {
              document.querySelector(".card_content_dark_mode").style.display =
                "none";
            } catch (err) {}
            try {
              document.querySelector(
                ".card_content_congrats_dark_mode"
              ).style.display = "flex";
            } catch (err) {}
            return;
          }

          function updateWidgetUI(mainObject, tierArrayIndex, down, up) {
            document.querySelector(
              `#shoptrade_product_price_${CURRENT_TIER_INDEX}`
            ).style.display = "none";
            if (down) {
              CURRENT_TIER_INDEX = mainObject.tiers[tierArrayIndex - 1].pk;
              lowTier = mainObject.tiers[currentTierIndex - 1].start;
              highTier = mainObject.tiers[currentTierIndex - 1].end;
              pk = mainObject.tier[currentTierIndex - 1].pk;
            } else if (up) {
              CURRENT_TIER_INDEX = mainObject.tiers[tierArrayIndex + 1].pk;
              lowTier = mainObject.tiers[currentTierIndex + 1].start;
              highTier = mainObject.tiers[currentTierIndex + 1].end;
              pk = mainObject.tiers[currentTierIndex + 1].pk;
            }
            document.querySelector(
              `#shoptrade_product_price_${CURRENT_TIER_INDEX}`
            ).style.display = "block";

            let width = computeBarWidthSpend(
              lowTier,
              highTier,
              mainObject.total_price
            );
            progressBar.style.width = `${width}%`;
            determinator = document.querySelector(
              `.shopify_determinator_${CURRENT_TIER_INDEX}`
            );
            let determinatorDif = highTier - mainObject.total_price;
            determinator.innerHTML = `${determinatorDif.toFixed(2)}`;
            try {
              const futureDeal = document.querySelector(
                `.shopify_tier_value_${pk}`
              ).innerHTML;
              future_deal_discount.innerHTML = `${futureDeal}`;
            } catch (err) {}
          }

          if (mainObject.total_price >= highTier) {
            updateWidgetUI(mainObject, currentTierIndex, false, true);
          } else if (mainObject.total_price + 1 < lowTier) {
            updateWidgetUI(mainObject, currentTierIndex, true, false);
          } else {
            let width = computeBarWidthSpend(
              lowTier,
              highTier,
              mainObject.total_price
            );
            progressBar.style.width = `${width}%`;
            let determinatorDif = highTier - mainObject.total_price;
            determinator.innerHTML = `${determinatorDif.toFixed(2)}`;
            try {
              const futureDeal = document.querySelector(
                `.shopify_tier_value_${pk}`
              ).innerHTML;
              future_deal_discount.innerHTML = `${futureDeal}`;
            } catch (err) {}
          }
        }

        function computeQuantityWidget() {
          let lowTier = "";
          let highTier = "";
          let currentTierIndex = mainObject.tiers.length - 1;
          let pk = "";
          mainObject.tiers.forEach((tier, index) => {
            if (tier.pk == CURRENT_TIER_INDEX) {
              lowTier = tier.start;
              highTier = tier.end;
              currentTierIndex = index;
              pk = tier.pk;
            }
          });
          const checkIfLastTier =
            currentTierIndex == mainObject.tiers.length - 1 ? true : false;
          if (mainObject.total_quantity >= highTier && checkIfLastTier) {
            try {
              document.querySelector(".card_content").style.display = "none";
            } catch (err) {}
            try {
              document.querySelector(".card_content_congrats").style.display =
                "flex";
            } catch (err) {}
            try {
              document.querySelector(".card_content_dark_mode").style.display =
                "none";
            } catch (err) {}
            try {
              document.querySelector(
                ".card_content_congrats_dark_mode"
              ).style.display = "flex";
            } catch (err) {}
            return;
          }
          function updateWidgetUIQuantityBreaks(
            mainObject,
            currentTierIndex,
            up,
            down
          ) {
            document.querySelector(
              `#shoptrade_product_price_${CURRENT_TIER_INDEX}`
            ).style.display = "none";
            if (up) {
              CURRENT_TIER_INDEX = mainObject.tiers[currentTierIndex + 1].pk;
              lowTier = mainObject.tiers[currentTierIndex + 1].start;
              highTier = mainObject.tiers[currentTierIndex + 1].end;
              pk = mainObject.tiers[currentTierIndex + 1].pk;
            } else if (down) {
              CURRENT_TIER_INDEX = mainObject.tiers[currentTierIndex - 1].pk;
              lowTier = mainObject.tiers[currentTierIndex - 1].start;
              highTier = mainObject.tiers[currentTierIndex - 1].end;
              pk = mainObject.tiers[currentTierIndex - 1].pk;
            }

            document.querySelector(
              `#shoptrade_product_price_${CURRENT_TIER_INDEX}`
            ).style.display = "block";
            determinator = document.querySelector(
              `.shopify_determinator_${CURRENT_TIER_INDEX}`
            );
            let width = computeBarWidthQty(
              highTier,
              mainObject.total_quantity,
              lowTier
            );
            let determinatorDif = highTier - mainObject.total_quantity;
            determinator.innerHTML = `${determinatorDif}`;
            progressBar.style.width = `${width}%`;
            try {
              const futureDealInnerHtml = document.querySelector(
                `.shopify_tier_value_${pk}`
              ).innerHTML;
              future_deal_discount.innerHTML = `${futureDealInnerHtml}`;
            } catch (err) {}
          }

          if (mainObject.total_quantity >= highTier) {
            updateWidgetUIQuantityBreaks(
              mainObject,
              currentTierIndex,
              true,
              false
            );
            return 0;
          } else if (mainObject.total_quantity + 1 < lowTier) {
            updateWidgetUIQuantityBreaks(
              mainObject,
              currentTierIndex,
              false,
              true
            );
            return 0;
          } else {
            let width = computeBarWidthQty(
              highTier,
              mainObject.total_quantity,
              lowTier
            );
            progressBar.style.width = `${width}%`;
            let determinatorDif = highTier - mainObject.total_quantity;
            determinator.innerHTML = `${determinatorDif}`;
            try {
              const futureDealInnerHtml = document.querySelector(
                `.shopify_tier_value_${pk}`
              ).innerHTML;
              future_deal_discount.innerHTML = `${futureDealInnerHtml}`;
            } catch (err) {}
            return 0;
          }
        }

        if (deal_type == "spend_tiers") {
          computeSpendTiersWidget();
        } else {
          computeQuantityWidget();
        }
      }

      function setupModal() {
        const modal = document.getElementById("mySpendifyModal");
        const btn = document.querySelector(".footer__details");
        const span = document.getElementsByClassName("spendify-modal-close")[0];
        btn.onclick = function () {
          modal.style.display = "block";
        };
        span.onclick = function () {
          modal.style.display = "none";
        };
        window.onclick = function (event) {
          if (event.target == modal) {
            modal.style.display = "none";
          }
        };
      }

      function hideAdditionalPaymentButtons() {
        const buttons = document.querySelector(".shopify-payment-button");
        if (buttons) {
          buttons.style.display = "none";
        }
      }

      sendRequest();
      checkAgainstVarian();
      hideAdditionalPaymentButtons();
    }
  }

  (function () {
    const head = document.head || document.getElementsByTagName("head")[0];
    uploadFont(head);
    uploadStyle(head);
    addJquery(head);
    function uploadFont(head) {
      const link = document.createElement("link");
      link.href =
        "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap";
      link.rel = "stylesheet";
      head.appendChild(link);
    }

    function uploadStyle(head) {
      const css = `
      .shoptrade_item_title {
        display: block;
        text-decoration: none;
        text-transform: none;
        color: #51baf7;
      }
      
      .shoptrade_line_item_price {
        display: block;
        font-weight: bold;
        color: rgb(217, 83, 79);
      }
  
      .cart__subtotal__discount {
        display: block;
        font-weight: bold;
        color: rgb(217, 83, 79);
        font-size: 17px;
      }
      `;
      const style = document.createElement("style");
      style.type = "text/css";
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
      head.appendChild(style);
    }

    function addJquery(head) {
      if (typeof jQuery === "undefined") {
        script = document.createElement("script");
        script.onload = function () {
          init();
        };
        script.type = "text/javascript";
        script.src = "https://code.jquery.com/jquery-3.5.1.min.js";
        script.setAttribute(
          "integrity",
          "sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0="
        );
        script.setAttribute("crossorigin", "anonymous");
        head.appendChild(script);
      } else {
        init();
      }
    }
  })();

  /*
  {
    "cart_items": [
      {
        "variant_id": 123,
        "total_price": 123,
        "quantity": 123
      },
      {
        "variant_id": 111,
        "total_price": 111,
        "quantity": 111
      }
    ],
    "variant_id": 1234
  }
  */

  /* {
    "base_quantity": 111,
    "total_quantity": 111,
    "base_price": 11,
    "total_price": 11,
    "tiers": [
      {
        "pk": 0,
        ""
      },
      {
        "pk": 1
        "start": "20",
        "stop" : "30",
      }
    ],
    "selected_tier": ""
  }
  */
  // {
  //   "line_items": [
  //       {
  //           "key": "35937823359141:e81d63e188b042c8cdc62f0007fab8f3",
  //           "original_price": 120.0,
  //           "current_discount": 36.0,
  //           "line_item_message": "Order at least 500 and get 60 discount!"
  //       },
  //       {
  //           "key": "35937819164837:c62ba7114473df651daaa60d6cfc66ba",
  //           "original_price": 204.0,
  //           "current_discount": 61.2,
  //           "line_item_message": "Order at least 500 and get 60 discount!"
  //       }
  //   ],
  //   "code": "SPDFY-135"
  // }

  function increase() {
    let increaseQuantityWith = 1;
    try {
      let quantityValue = document.querySelector('[name="quantity"]').value;
      increaseQuantityWith = quantityValue;
    } catch (err) {}
    return parseInt(increaseQuantityWith);
  }
});
